<template>
    <div class="testimonial-card">
        <div v-if="$slots.image" class="testimonial-card__image">
            <slot name="image" />
        </div>
        <div class="testimonial-card__content">
            <slot name="content" />
        </div>
        <div v-if="$slots.footer" class="testimonial-card__footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<style lang="scss">
    .testimonial-card {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: left;
        box-shadow: var(--joy-core-elevation-1);
        padding: var(--joy-core-spacing-6);
        border-radius: var(--joy-core-radius-4);
        background-color: var(--joy-color-neutral-0);
        border: 1px solid var(--joy-color-neutral-20);
        max-width: 320px;
        height: 100%;

        &__image {
            position: relative;
            margin-bottom: var(--joy-core-spacing-4);

            > img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        &__content {
            flex: 1;
        }
        &__footer {
            margin-top: var(--joy-core-spacing-4);
            height: auto !important;
        }
    }
</style>
